export default __webpack_public_path__ + "static/media/mobile-ticket-icon-2.aec28f88.png";